let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("MvKo8")).then(() => parcelRequire('86hzk'));